import React, { useState } from 'react';
import { Search, Bell, Plus } from 'lucide-react';
import { useAuth, ROLES } from '../context/AuthContext';
import LeadModal from './LeadModal';

const Topbar = () => {
  const { user } = useAuth();
  const [showModal, setShowModal] = useState(false);

  return (
    <header className="topbar">
      <div className="topbar-search">
        <Search size={18} color="var(--text-light)" />
        <input type="text" placeholder="Buscar póliza, cliente o teléfono..." />
      </div>

      <div className="topbar-actions">
        {/* Solo Admin y Editor pueden crear Leads */}
        {(user?.role === ROLES.ADMIN || user?.role === ROLES.EDITOR) && (
          <button className="btn btn-primary" style={{ marginRight: '1rem' }} onClick={() => setShowModal(true)}>
            <Plus size={18} />
            Nuevo Lead
          </button>
        )}

        <button className="action-btn" style={{ padding: '0.5rem' }}>
          <Bell size={20} />
        </button>

        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', paddingLeft: '1rem', borderLeft: '1px solid var(--border)' }}>
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: '0.85rem', fontWeight: 600, color: 'var(--text-main)' }}>{user?.name}</div>
            <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)' }}>{user?.role}</div>
          </div>
          <div className="avatar" title={`Usuario: ${user?.name}`}>{user?.initials || 'U'}</div>
        </div>
      </div>

      {showModal && <LeadModal onClose={() => setShowModal(false)} />}
    </header>
  );
};

export default Topbar;
